export const simpleEmailRegex = /(.+)@(.+){2,}\.(.+){2,}/;
